import { render } from "./NetfreeChecker.vue?vue&type=template&id=28ce149d&scoped=true"
import script from "./NetfreeChecker.vue?vue&type=script&lang=js"
export * from "./NetfreeChecker.vue?vue&type=script&lang=js"

import "./NetfreeChecker.vue?vue&type=style&index=0&id=28ce149d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ce149d"]])

export default __exports__